/*
 * @Author: your name
 * @Date: 2020-07-11 10:12:20
 * @LastEditTime: 2020-07-29 14:53:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-lib-ui/examples/demos/form-build-demo/form-schema-config/editors/calc-rule-config.js
 */
import Vue from 'vue'
import PeopleSelectDefaultValueConfig from './people-select-default-value-config'
import DepartmentSelectDefaultValueConfig from './department-select-default-value-config'
import apis from '@/api'
// import { RuleParser, RuleExecutor } from 'x-lib-rule-engine'

const saveSimpleRule = (ruleData, globalData) => {
  return new Promise((resolve, reject) => {
    const request = {
      ...apis.SAVE_SIMPLE_RULE,
      params: { ...ruleData, menuId: globalData.menuId }
    }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve(resp)
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const saveAdvancedRule = (ruleData, globalData) => {
  return new Promise((resolve, reject) => {
    const request = { ...apis.SAVE_ADVANCED_RULE }
    request.params = { ...ruleData, menuId: globalData.menuId }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          if (resp.code === 'ok') {
            resolve(resp)
          }
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const queryFuncList = () => {
  return new Promise((resolve, reject) => {
    const request = { ...apis.QUERY_FUNC_LIST }
    Vue.prototype
      .$request(request)
      .asyncThen(
        (resp) => {
          resolve(resp)
        },
        (err) => {
          reject(err)
        }
      )
      .asyncErrorCatch((err) => {
        reject(err)
      })
  })
}

const validateRuleExpr = (rule) => {
  // const expr = RuleParser.parseRuleToExpr(rule)
  // const validateResult = RuleExecutor.validateRuleExpr(expr)
  // return validateResult
  return true
}

export default {
  editorConfigType: 'FORM_WIDGET_CALC_RULE',
  componentName: 'FormConfigWidgetCalcRule',
  configProperty: 'calcRules',
  peopleSelectExtras: { ...PeopleSelectDefaultValueConfig.extras },
  departmentSelectExtras: { ...DepartmentSelectDefaultValueConfig.extras },
  extras: {
    saveSimpleRule,
    saveAdvancedRule,
    queryFuncList,
    validateRuleExpr
  }
}
